export default __webpack_public_path__ + "static/media/master_b180.5db70514.jpg";